import { createFileRoute } from '@tanstack/react-router';
import { DocumentTranslationPage } from '../../features/documentTranslation/pages/DocumentTranslationPage';
import { documentTranslationKeys } from '../../features/documentTranslation/services/queries/documentTranslationQueries';
import { documentTranslationApi } from '../../features/documentTranslation/services/api/documentTranslationApi';

export const Route = createFileRoute('/_app/documentTranslation')({
  component: DocumentTranslationPage,
  loader: async ({ context: { queryClient } }) => {
    const [languageOptions, lastUsedLanguageData] = await Promise.all([
      queryClient.ensureQueryData({
        queryKey: documentTranslationKeys.options(),
        queryFn: () => documentTranslationApi.getTranslationOptionsAsync(),
        staleTime: Infinity,
      }),
      queryClient.ensureQueryData({
        queryKey: documentTranslationKeys.lastUsedLanguage(),
        queryFn: () => documentTranslationApi.getLastUsedLanguageAsync(),
        staleTime: Infinity,
      }),
    ]);
    return {
      languageOptions,
      lastUsedLanguage: lastUsedLanguageData.lastUsedLanguage,
    };
  },
});
